/* CAS DEIA · buscador predictivo. JavaScript nativo, cero dependencias. */
(function () {
  'use strict';

  var PANEL = null, INPUT = null, RESULTS = null, INITIAL = null, HINT = null;
  var DICT = null, CTRL = null, TIMER = null, ROT = null, LAST_FOCUS = null;
  var CFG = {};
  var RECENT_KEY = 'csd_recent_searches';

  /* ---------------- utilidades ---------------- */
  function norm(s) {
    return (s || '')
      .toLowerCase()
      .normalize('NFD').replace(/[̀-ͯ]/g, '')   // sin acentos
      .replace(/\b(sa|es|sos)\b/g, ' ')                    // particulas baleares
      .replace(/[^a-z0-9\s-]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }
  function singular(w) {
    if (w.length > 3 && /es$/.test(w)) return w.slice(0, -2);
    if (w.length > 3 && /s$/.test(w)) return w.slice(0, -1);
    return w;
  }
  function normWords(s) { return norm(s).split(' ').filter(Boolean).map(singular); }

  /*
   * ⚠️ `suggest.json` NO DEVUELVE CÉNTIMOS, y esa es toda la historia de este fallo.
   *
   * Casi todas las APIs de Shopify dan el precio en céntimos y como número (`/products/x.js` dice
   * 5200 para una pulsera de 52 €). Pero el buscador devuelve `price: "52.00"`: ya en euros y como
   * TEXTO. Aquí se dividía entre 100, así que el escaparate enseñaba **0,52 €** por una pulsera de
   * 52 € (Daniel, 24-ago-2026). Un precio mal en la lupa es de lo peor que puede pasar en una
   * tienda: o la gente cree que regalas las piezas, o piensa que la web está rota.
   *
   * Se acepta texto Y número por si Shopify cambia de idea, y se admite la coma decimal porque hay
   * mercados donde el precio viene como "52,00".
   */
  function aNumero(v) {
    if (typeof v === 'number') return v;
    var s = String(v == null ? '' : v).trim().replace(/[^\d.,-]/g, '');
    if (!s) return NaN;
    if (s.indexOf(',') > -1 && s.indexOf('.') > -1) s = s.replace(/\./g, '').replace(',', '.');
    else if (s.indexOf(',') > -1) s = s.replace(',', '.');
    return parseFloat(s);
  }
  /*
   * ⚠️ EL FORMATO LO MANDA LA TIENDA, NO EL IDIOMA DEL NAVEGADOR. CAS DEIÀ escribe los precios como
   * "€75,00": símbolo DELANTE y coma decimal. Esto usaba el idioma de la página, que en inglés da
   * "€52.00", así que en el mismo panel salían "€52.00" en los resultados y "€48,00" dos dedos más
   * abajo en los más vendidos (que los pinta Liquid con el formato de la tienda).
   *
   * Ningún idioma de Intl da esa combinación: 'es' pone el símbolo detrás ("52,00 €") y 'en' usa
   * punto. Así que el NÚMERO se formatea al estilo continental y el símbolo se pone delante a mano.
   * El símbolo se saca de Intl y no se escribe "€" a pelo, para que un mercado en otra moneda no
   * acabe enseñando euros que no son.
   */
  function money(valor, currency) {
    var n = aNumero(valor);
    if (!isFinite(n)) return '';
    var cur = currency || 'EUR';
    try {
      var num = new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(n);
      var simbolo = (0).toLocaleString('en', { style: 'currency', currency: cur }).replace(/[\d.,\s]/g, '');
      return (simbolo || cur) + num;
    } catch (e) { return n.toFixed(2) + ' €'; }
  }
  function imgUrl(u, w) {
    u = String(u == null ? '' : u).trim();
    if (!(/^https:\/\/cdn\.shopify\.com\//.test(u) || u.charAt(0) === '/')) return '';
    if (!w) return u;
    /* pedimos a Shopify el ancho justo x2, para que se vea nitido en retina */
    return u + (u.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }
  function safeUrl(u) {
    u = String(u == null ? '' : u).trim();
    if (u.charAt(0) === '/' && u.charAt(1) !== '/') return u;      // ruta interna
    try {
      var abs = new URL(u, location.origin);
      if (abs.origin === location.origin && /^https?:$/.test(abs.protocol)) return abs.pathname + abs.search;
    } catch (e) {}
    return '#';
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function track(name, params) {
    if (params && typeof params.search_term === 'string') params.search_term = params.search_term.slice(0, 120);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name }, params || {}));
  }

  /* ---------------- diccionario ---------------- */
  function loadDict() {
    if (DICT || !CFG.dictUrl) return Promise.resolve(DICT);
    return fetch(CFG.dictUrl).then(function (r) { return r.json(); })
      .then(function (d) { DICT = d; return d; })
      .catch(function () { DICT = { catalogo: {}, categoria: {}, atributo: {}, padre: {} }; return DICT; });
  }

  /* devuelve {query, corregido, aplicados} */
  function applyDict(raw) {
    var words = normWords(raw);
    if (!DICT || !words.length) return { query: raw, corregido: null, aplicados: 0 };

    var out = [], corregido = null, aplicados = 0;

    words.forEach(function (w) {
      var entrada = null, grupo = null;
      ['catalogo', 'categoria', 'atributo'].forEach(function (g) {
        if (entrada) return;
        var tabla = DICT[g] || {};
        Object.keys(tabla).forEach(function (clave) {
          if (entrada) return;
          var e = tabla[clave] || {};
          var alias = e.alias || [];
          for (var i = 0; i < alias.length; i++) {
            var a = norm(alias[i]);
            if (a === w || singular(a) === w || a.split(' ').map(singular).join(' ') === w) {
              entrada = e; grupo = g; return;
            }
          }
        });
      });
      if (entrada) {
        aplicados++;
        out.push(entrada.buscar || w);
        if (!corregido && entrada.mostrar) corregido = entrada.mostrar;
      } else {
        out.push(w);
      }
    });

    return { query: out.join(' '), corregido: corregido, aplicados: aplicados };
  }

  function padre(q) {
    if (!DICT) return null;
    var n = norm(q);
    var pad = DICT.padre || {};
    var keys = Object.keys(pad);
    for (var i = 0; i < keys.length; i++) {
      if (norm(keys[i]) === n) {
        var e = (DICT.categoria || {})[pad[keys[i]]];
        if (e) return { buscar: e.buscar, mostrar: e.mostrar };
      }
    }
    var w = normWords(q);
    var cats = DICT.categoria || {};
    var ck = Object.keys(cats);
    for (var j = 0; j < w.length; j++) {
      for (var k = 0; k < ck.length; k++) {
        var al = cats[ck[k]].alias || [];
        for (var z = 0; z < al.length; z++) {
          if (singular(norm(al[z])) === w[j]) return { buscar: cats[ck[k]].buscar, mostrar: cats[ck[k]].mostrar };
        }
      }
    }
    return null;
  }

  /* ---------------- recientes ---------------- */
  function getRecent() {
    try { return JSON.parse(localStorage.getItem(RECENT_KEY) || '[]'); } catch (e) { return []; }
  }
  function pushRecent(term) {
    if (!term) return;
    var l = getRecent().filter(function (t) { return t !== term; });
    l.unshift(term);
    try { localStorage.setItem(RECENT_KEY, JSON.stringify(l.slice(0, 4))); } catch (e) {}
    paintRecent();
  }
  function paintRecent() {
    var box = PANEL.querySelector('[data-csd-recent]');
    if (!box) return;
    var l = getRecent();
    box.hidden = l.length === 0;
    var cont = box.querySelector('[data-csd-recent-list]');
    if (cont) cont.innerHTML = l.map(function (t) {
      return '<button type="button" class="csd-chip" data-csd-term="' + esc(t) + '">' + esc(t) + '</button>';
    }).join('');
  }

  /* ---------------- peticion ---------------- */
  function suggest(q) {
    if (CTRL) CTRL.abort();
    CTRL = new AbortController();
    var url = CFG.searchUrl + '/suggest.json?q=' + encodeURIComponent(q)
      + '&resources[type]=product,collection,page,article'
      + '&resources[limit]=6'
      + '&resources[options][unavailable_products]=last';
    return fetch(url, { signal: CTRL.signal })
      .then(function (r) { return r.json(); })
      .then(function (d) { return (d && d.resources && d.resources.results) || {}; });
  }

  /* ---------------- pintado ---------------- */
  function prodRow(p, i) {
    var agotado = p.available === false;
    return '<a class="csd-pr' + (agotado ? ' is-out' : '') + '" href="' + esc(safeUrl(p.url)) + '" data-csd-hit="product" data-csd-pos="' + i + '">'
      + '<img src="' + esc(imgUrl(p.featured_image && p.featured_image.url, 320)) + '" alt="" loading="lazy" width="54" height="68">'
      + '<span class="csd-pr__nm"><b>' + esc(p.title) + '</b>'
      + (agotado ? '<span class="csd-pr__sub">' + esc(CFG.txtSoldOut) + '</span>' : '')
      + '</span>'
      /*
       * ⚠️ Y EL PRECIO TACHADO NO SALÍA NUNCA. `suggest.json` no manda `compare_at_price`: manda
       * `compare_at_price_min` y `_max`. Como aquí se leía el nombre que no existe, la condición era
       * siempre falsa y una pieza rebajada aparecía a precio de rebaja y sin el precio anterior al
       * lado, o sea sin que se viera que estaba rebajada. Con el Summer Sale en marcha eso es
       * regalar el descuento sin que se note.
       *
       * Rebajado = precio comparado MAYOR que el de venta. Se comparan NÚMEROS y no textos: como
       * texto, "9.00" > "10.00" y una pieza de 10 € rebajada desde 9 € saldría como oferta.
       */
      + '<span class="csd-pr__eur">' + money(p.price, CFG.currency)
      + (function () {
        var antes = aNumero(p.compare_at_price_min != null ? p.compare_at_price_min : p.compare_at_price);
        var ahora = aNumero(p.price);
        if (!isFinite(antes) || !isFinite(ahora) || antes <= ahora) return '';
        return ' <s>' + money(antes, CFG.currency) + '</s>';
      })()
      + '</span></a>';
  }

  function paintResults(res, q, corregido, total) {
    var nProd = (res.products || []).length;
    var nCol  = (res.collections || []).length;
    var nAyu  = ((res.pages || []).length + (res.articles || []).length);
    if (nProd + nCol + nAyu === 0) return paintEmpty(RAW || q, corregido);

    var h = '';
    if (corregido) {
      h += '<div class="csd-hint">' + CFG.iconSearch + '<span>' + esc(CFG.txtDidYouMean) + ' <b>' + esc(corregido) + '</b></span></div>';
    }
    var prods = res.products || [];
    if (prods.length) {
      h += '<div class="csd-bl"><p class="csd-lab">' + esc(CFG.txtProducts) + '</p>' + prods.slice(0, 6).map(prodRow).join('') + '</div>';
    }
    var cols = res.collections || [];
    if (cols.length) {
      h += '<div class="csd-bl"><p class="csd-lab">' + esc(CFG.txtCategories) + '</p><div class="csd-chips">'
        + cols.slice(0, 3).map(function (c) { return '<a class="csd-chip" href="' + esc(safeUrl(c.url)) + '" data-csd-hit="collection">' + esc(c.title) + '</a>'; }).join('')
        + '</div></div>';
    }
    var ayuda = (res.pages || []).concat(res.articles || []);
    if (ayuda.length) {
      h += '<div class="csd-bl"><p class="csd-lab">' + esc(CFG.txtHelp) + '</p>'
        + ayuda.slice(0, 2).map(function (a) { return '<a class="csd-acc" href="' + esc(safeUrl(a.url)) + '" data-csd-hit="page"><span>' + esc(a.title) + '</span></a>'; }).join('')
        + '</div>';
    }

    h += '<a class="csd-cta" href="' + CFG.searchUrl + '?q=' + encodeURIComponent(q) + '&options[prefix]=last">'
      + esc(CFG.txtSeeAll).replace('{n}', function(){ return total; }) + '</a>';

    RESULTS.innerHTML = h;
    INITIAL.hidden = true;
    RESULTS.hidden = false;
  }

  function paintEmpty(q, corregido) {
    var sug = [];
    if (corregido) sug.push(corregido);
    function add(v){ if(v && sug.indexOf(v)===-1 && sug.length<3) sug.push(v); }
    if (DICT) {
      var w = normWords(q)[0] || '';
      var cat = DICT.catalogo || {}, ctg = DICT.categoria || {};
      Object.keys(cat).forEach(function (k) { if (w && k.indexOf(w.slice(0, 3)) === 0) add(cat[k].mostrar); });
      Object.keys(ctg).forEach(function (k) { add(ctg[k].mostrar); });
    }
    RESULTS.innerHTML =
      '<div class="csd-bl"><p class="csd-lab">' + esc(CFG.txtNoResults).replace('{q}', function(){ return esc(q); }) + '</p>'
      + '<div class="csd-chips">' + sug.slice(0, 3).map(function (s) {
          return '<button type="button" class="csd-chip" data-csd-term="' + esc(s) + '">' + esc(s) + '</button>';
        }).join('') + '</div></div>'
      + (CFG.bestHtml || '')
      + '<div class="csd-bl"><a class="csd-acc" href="' + esc(CFG.helpUrl) + '"><span>' + esc(CFG.txtNeedHelp) + '</span></a></div>';
    INITIAL.hidden = true;
    RESULTS.hidden = false;
    track('search_no_results', { search_term: q });
  }

  /* ---------------- ciclo de busqueda ---------------- */
  var RAW = '';
  function run(raw) {
    RAW = raw;
    var d = applyDict(raw);
    track('search_query', { search_term: raw, normalized: d.query });

    suggest(d.query).then(function (res) {
      var total = (res.products || []).length;
      if (!total) {
        var p = padre(raw);
        if (p) {
          return suggest(p.buscar).then(function (r2) {
            paintResults(r2, p.buscar, d.corregido || p.mostrar, (r2.products || []).length);
          });
        }
      }
      paintResults(res, d.query, d.corregido, total);
    }).catch(function (e) { if (e.name !== 'AbortError') paintEmpty(raw); });
  }

  /* ---------------- abrir y cerrar ---------------- */
  function cabecera() {
    return document.querySelector('#shopify-section-header, .js-header, header');
  }

  /* El panel abre exactamente a la misma altura que el carrito: el CSS ya lo
     coloca a 15px arriba y a los lados. No se recoloca por JS. */
  function colocar() {
    var h = cabecera();
    if (h) h.classList.add('csd-header-on-top');
  }

  function open(trigger) {
    colocar();
    LAST_FOCUS = trigger || document.activeElement;
    PANEL.setAttribute('open', '');
    PANEL.setAttribute('aria-hidden', 'false');
    var ov = document.querySelector('.js-overlay');
    if (ov) ov.classList.add('is-visible');
    document.documentElement.style.overflow = 'hidden';
    paintRecent();
    setTimeout(function () { INPUT.focus(); }, 60);
    startRotation();
    track('search_open', {});
  }
  function close() {
    var h = cabecera();
    if (h) h.classList.remove('csd-header-on-top');
    PANEL.removeAttribute('open');
    PANEL.setAttribute('aria-hidden', 'true');
    var ov = document.querySelector('.js-overlay');
    if (ov) ov.classList.remove('is-visible');
    document.documentElement.style.overflow = '';
    stopRotation();
    if (LAST_FOCUS && LAST_FOCUS.focus) LAST_FOCUS.focus();
  }

  function startRotation() {
    if (!CFG.placeholders || CFG.placeholders.length < 2) return;
    var i = 0;
    stopRotation();
    ROT = setInterval(function () {
      i = (i + 1) % CFG.placeholders.length;
      INPUT.setAttribute('placeholder', CFG.placeholders[i]);
    }, 4000);
  }
  function stopRotation() { if (ROT) { clearInterval(ROT); ROT = null; } }

  function trapFocus(e) {
    if (e.key !== 'Tab') return;
    var f = PANEL.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /* ---------------- arranque ---------------- */
  function init() {
    PANEL = document.querySelector('[data-csd-search]');
    if (!PANEL) return;
    CFG = JSON.parse(PANEL.getAttribute('data-csd-config') || '{}');
    INPUT = PANEL.querySelector('[data-csd-input]');
    RESULTS = PANEL.querySelector('[data-csd-results]');
    INITIAL = PANEL.querySelector('[data-csd-initial]');
    loadDict();

    /* la lupa: capturamos antes que el tema para que no abra su buscador viejo */
    document.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('.show-search-link');
      if (!t) return;
      e.preventDefault();
      e.stopPropagation();
      open(t);
    }, true);

    PANEL.addEventListener('click', function (e) {
      if (e.target.closest('[data-csd-close]')) { e.preventDefault(); close(); return; }
      var chip = e.target.closest('[data-csd-term]');
      if (chip) {
        INPUT.value = chip.getAttribute('data-csd-term');
        track('search_suggestion_click', { search_term: INPUT.value });
        onType();
        INPUT.focus();
        return;
      }
      var clear = e.target.closest('[data-csd-clear]');
      if (clear) { try { localStorage.removeItem(RECENT_KEY); } catch (er) {} paintRecent(); return; }
      var hit = e.target.closest('[data-csd-hit]');
      if (hit) {
        track('search_result_click', { type: hit.getAttribute('data-csd-hit'), position: hit.getAttribute('data-csd-pos') || 0 });
        pushRecent(INPUT.value.trim());
      }
    });

    window.addEventListener('resize', function () { if (PANEL.hasAttribute('open')) colocar(); });
    var ov = document.querySelector('.js-overlay');
    if (ov) ov.addEventListener('click', function () { if (PANEL.hasAttribute('open')) close(); });

    document.addEventListener('keydown', function (e) {
      if (!PANEL.hasAttribute('open')) return;
      if (e.key === 'Escape') close();
      trapFocus(e);
    });

    INPUT.addEventListener('focus', stopRotation);
    INPUT.addEventListener('input', onType);
    INPUT.form && INPUT.form.addEventListener('submit', function () { pushRecent(INPUT.value.trim()); });
  }

  function onType() {
    var q = INPUT.value.trim();
    clearTimeout(TIMER);
    if (q.length < 2) {
      if (CTRL) CTRL.abort();
      RESULTS.hidden = true;
      INITIAL.hidden = false;
      return;
    }
    TIMER = setTimeout(function () { loadDict().then(function () { run(q); }); }, 250);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
